@import '../../themes/capsule.globals';

:host {
  --ring-3-size: 480px;
  --ring-2-size: 360px;
  --ring-1-size: 240px;
  --ring-0-size: 120px;
  --center-icon-size: 64px;

  --default-theme-ring-3-opacity: 0.05;
  --default-theme-ring-2-opacity: 0.1;
  --default-theme-ring-1-opacity: 0.2;
  --default-theme-ring-0-opacity: 0.3;

  position: relative;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  clip-path: content-box;
}

:host > cpsl-text {
  z-index: 1;
}

:host > .backgroundContainer {
  position: relative;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

:host > .backgroundContainer > .background {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-25%);
  left: 0;
  right: 0;
  z-index: 0;
}

:host > .backgroundContainer > .background > .ring {
  position: absolute;
  top: 45px;
  left: 50%;
  transform: translate(-50%, -50%);
  flex-shrink: 0;
  transition: box-shadow 0.3s;
}

:host(.connection),
:host(.externalWalletConnection) > .backgroundContainer > .background {
  .ring1 {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.07);
  }

  .ring2 {
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05);
  }

  .ring3 {
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.04);
  }
}

:host(.pending) > .backgroundContainer > .background {
  .ring0 {
    box-shadow: 0px 0px 20px var(--cpsl-color-accent-0, color-mix(in srgb, var(--cpsl-color-foreground-0), transparent 80%));
  }

  .ring1 {
    box-shadow: 0px 0px 20px var(--cpsl-color-accent-0, color-mix(in srgb, var(--cpsl-color-foreground-0), transparent 92%));
  }

  .ring2 {
    box-shadow: 0px 0px 12px var(--cpsl-color-accent-0, color-mix(in srgb, var(--cpsl-color-foreground-0), transparent 94%));
  }

  .ring3 {
    box-shadow: 0px 0px 12px var(--cpsl-color-accent-0, color-mix(in srgb, var(--cpsl-color-foreground-0), transparent 96%));
  }
}

:host(.failed) > .backgroundContainer > .background > {
  .ring0 {
    box-shadow: 0px 0px 20px rgba(240, 68, 56, 0.1);
  }

  .ring1 {
    box-shadow: 0px 0px 20px rgba(240, 68, 56, 0.08);
  }

  .ring2 {
    box-shadow: 0px 0px 20px rgba(240, 68, 56, 0.06);
  }

  .ring3 {
    box-shadow: 0px 0px 20px rgba(240, 68, 56, 0.04);
  }
}

:host(.approved) > .backgroundContainer > .background {
  .ring1 {
    box-shadow: 0px 0px 20px rgb(219, 0, 179, 0.1);
  }

  .ring2 {
    box-shadow: 0px 0px 20px rgb(219, 0, 51, 0.1);
  }

  .ring3 {
    box-shadow: 0px 0px 20px rgb(254, 83, 48, 0.1);
  }
}

:host(.add) > .backgroundContainer > .background {
  .ring0 {
    box-shadow: 0px 0px 20px rgba(240, 68, 56, 0.1);
  }

  .ring1 {
    box-shadow: 0px 0px 20px rgb(219, 0, 179, 0.1);
  }

  .ring2 {
    box-shadow: 0px 0px 20px rgb(219, 0, 51, 0.1);
  }

  .ring3 {
    box-shadow: 0px 0px 20px rgb(254, 83, 48, 0.1);
  }
}

:host(.failed) > .backgroundContainer > .background.defaultTheme > {
  .ring0 {
    box-shadow: 0px 0px 20px color-mix(in srgb, var(--cpsl-color-utility-red), transparent 90%);
  }

  .ring1 {
    box-shadow: 0px 0px 20px color-mix(in srgb, var(--cpsl-color-utility-red), transparent 92%);
  }

  .ring2 {
    box-shadow: 0px 0px 12px color-mix(in srgb, var(--cpsl-color-utility-red), transparent 94%);
  }

  .ring3 {
    box-shadow: 0px 0px 12px color-mix(in srgb, var(--cpsl-color-utility-red), transparent 96%);
  }
}

:host(.approved) > .backgroundContainer > .background.defaultTheme {
  .ring1 {
    box-shadow: 0px 0px 20px var(--cpsl-color-accent-0, color-mix(in srgb, var(--cpsl-color-foreground-0), transparent 93%));
  }

  .ring2 {
    box-shadow: 0px 0px 12px var(--cpsl-color-accent-0, color-mix(in srgb, var(--cpsl-color-foreground-0), transparent 95%));
  }

  .ring3 {
    box-shadow: 0px 0px 12px var(--cpsl-color-accent-0, color-mix(in srgb, var(--cpsl-color-foreground-0), transparent 96%));
  }
}

:host(.add) > .backgroundContainer > .background.defaultTheme {
  .ring0 {
    box-shadow: 0px 0px 20px var(--cpsl-color-accent-0, color-mix(in srgb, var(--cpsl-color-foreground-0), transparent 90%));
  }

  .ring1 {
    box-shadow: 0px 0px 20px var(--cpsl-color-accent-0, color-mix(in srgb, var(--cpsl-color-foreground-0), transparent 93%));
  }

  .ring2 {
    box-shadow: 0px 0px 12px var(--cpsl-color-accent-0, color-mix(in srgb, var(--cpsl-color-foreground-0), transparent 95%));
  }

  .ring3 {
    box-shadow: 0px 0px 12px var(--cpsl-color-accent-0, color-mix(in srgb, var(--cpsl-color-foreground-0), transparent 96%));
  }
}

:host(:not(.failed)) > .backgroundContainer > .background.defaultTheme > {
  .ring0 {
    opacity: var(--default-theme-ring-0-opacity);
  }

  .ring1 {
    opacity: var(--default-theme-ring-1-opacity);
  }

  .ring2 {
    opacity: var(--default-theme-ring-2-opacity);
  }

  .ring3 {
    opacity: var(--default-theme-ring-3-opacity);
  }
}

:host > .backgroundContainer > .background > .ring3 {
  width: var(--ring-3-size);
  height: var(--ring-3-size);
  border-radius: var(--ring-3-size);
}

:host > .backgroundContainer > .background > .ring2 {
  width: var(--ring-2-size);
  height: var(--ring-2-size);
  border-radius: var(--ring-2-size);
}

:host > .backgroundContainer > .background > .ring1 {
  width: var(--ring-1-size);
  height: var(--ring-1-size);
  border-radius: var(--ring-1-size);
}

:host > .backgroundContainer > .background > .ring0 {
  width: var(--ring-0-size);
  height: var(--ring-0-size);
  border-radius: var(--ring-0-size);
}

:host > .backgroundContainer > .background > .ringCenter {
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  top: 45px;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;

  width: 120px;
  height: 120px;
  border-radius: 82px;

  & img {
    width: 100%;
    height: 100%;
    animation: spin 2s linear infinite;

    &.approvedImage {
      height: 160px;
      width: 160px;
    }

    &.connectionImage {
      height: 160px;
      width: 160px;
    }

    &.pendingImage {
      height: 90px;
      width: 90px;
    }
  }
}

:host > .backgroundContainer > .background > .fadeOut {
  position: absolute;
  height: 19%;
  top: 15%;
  right: 0;
  left: 0;
  background: linear-gradient(180deg, color-mix(in srgb, var(--cpsl-color-background-0), transparent 100%) 0%, var(--cpsl-color-background-0) 100%);
}

:host > .backgroundContainer > .background > .cover {
  position: absolute;
  height: 100%;
  top: 34%;
  right: 0;
  left: 0;
  background: var(--cpsl-color-background-0);
}

:host > .backgroundContainer > .children {
  z-index: 1;
}

:host(.connection) > .backgroundContainer > .background > .ringCenter > .connectDiagramContainer {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
}

.centerIcon {
  position: absolute;

  --icon-color: var(--cpsl-color-accent-0, var(--cpsl-color-foreground-0));
  --width: var(--center-icon-size);
  --height: var(--center-icon-size);
}

.externalConnectionIcon {
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  animation: spin 2s linear infinite;
  position: absolute;

  --width: 120px;
  --height: 120px;
}

:host(.approved) > .backgroundContainer > .background > .ringCenter.defaultTheme {
  border: 4px solid var(--cpsl-color-accent-0, var(--cpsl-color-foreground-0));
}

.customImageContainer {
  position: absolute;

  display: flex;
  justify-content: center;
  align-items: center;

  width: var(--ring-0-size);
  height: var(--ring-0-size);
  border-radius: var(--ring-0-size);

  border: 2px solid var(--cpsl-color-background-0);

  box-sizing: border-box;
  overflow: hidden;
}
